var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-page"},[_c('main-pay',{attrs:{"mount":_vm.mount,"curSelect":_vm.payType,"showAliPay":false,"orderInfo":_vm.orderInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }